import { render, staticRenderFns } from "./ViewBilling.vue?vue&type=template&id=653a5daa&"
import script from "./ViewBilling.vue?vue&type=script&lang=js&"
export * from "./ViewBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports